import { EmailStatus, PaymentMethod, PaymentSource, PaymentStatus } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
// Optional, coerced positive-int page params (no default — matches the legacy
// `@IsInt @IsOptional @Min(1) @Transform(parseInt)` on these list queries).
const optionalPage = z.coerce.number().int().min(1).optional();
export const listBookingPaymentsQuerySchema = z.object({
    method: z.nativeEnum(PaymentMethod).optional(),
    page: optionalPage,
    pageSize: optionalPage,
    search: z.string().optional(),
    source: z.nativeEnum(PaymentSource).optional(),
    status: z.nativeEnum(PaymentStatus).optional(),
});
export const listLegacyPaymentsQuerySchema = z.object({
    emailStatus: z.nativeEnum(EmailStatus).optional(),
    page: optionalPage,
    pageSize: optionalPage,
    search: z.string().optional(),
    status: z.nativeEnum(PaymentStatus).optional(),
});
